import { Button, Result } from "antd";
import { Link } from "react-router-dom";
import { Screens } from "@constants/screens";
import { TranslationService } from "@services/translate";

const NotFound = (): JSX.Element => (
  <Result
    status="404"
    title="404"
    subTitle={TranslationService.t("txt_screen_not_found")}
    extra={
      <Button type="primary">
        <Link to={Screens.Root.path()}>{TranslationService.t("txt_back")}</Link>
      </Button>
    }
  />
);

export default NotFound;
